import { Box, CircularProgress } from "@mui/material"
import { useThemeContext } from '../theme/ThemeContext';

export const ISProgress = () => {
    const { theme } = useThemeContext()

    return <Box justifyContent="center" display="flex" alignItems="center" height="100%">
             <CircularProgress sx={{color: theme.palette.background.default}} thickness={2} size={150}/>
        </Box>
}